import { Box, styled } from "@mui/material";

export const StyledContainer = styled(Box)(({ theme: { spacing } }) => ({
  padding: spacing(5),
  background: "white",
  borderRadius: "6px",
  border: "1px solid #F3F3F3",
  // minHeight: "680px",
}));
